import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import Button from "../../shared/components/FormElements/Button";

const SignupSuccess = () => {
	return (
		<div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
			<div className="max-w-md w-full text-center">
				<div className="bg-white rounded-2xl shadow-xl p-8">
					<div className="mb-6">
						<CheckCircleIcon className="size-16 text-green-500 mx-auto mb-4" />
						<h1 className="text-3xl font-bold text-gray-900 mb-2">
							Welkom!
						</h1>
						<p className="text-lg text-gray-600">
							Je account is succesvol aangemaakt
						</p>
					</div>

					<div className="bg-green-50 rounded-lg p-4 mb-6">
						<h3 className="font-semibold text-green-800 mb-2">
							Wat gebeurt er nu?
						</h3>
						<ul className="text-left text-sm text-green-700 space-y-2">
							<li>
								• Je gratis proefperiode van 31 dagen is gestart
							</li>
							<li>• Je ontvangt een bevestigingsmail</li>
							<li>
								• Je wordt pas na de proefperiode in rekening
								gebracht
							</li>
							<li>
								• Je hebt volledige toegang tot alle functies
							</li>
						</ul>
					</div>

					<div className="space-y-4">
						<Button href="/dashboard" size="large" fullWidth>
							Ga naar je dashboard
						</Button>

						<Button href="/onboarding" ghost size="large" fullWidth>
							Start met instellen
						</Button>
					</div>

					<div className="mt-6 text-sm text-gray-500">
						<p>
							Heb je vragen? Neem contact op via{" "}
							<a
								href="mailto:support@example.com"
								className="text-purple-600 hover:underline"
							>
								support@example.com
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SignupSuccess;
